export default (func => {
  let didRun = false;
  let result;
  return function onced(...args) {
    if (!didRun) {
      didRun = true;
      result = func(...args);
    }

    return result;
  };
});